import axios from "./config";
import { API } from "./api";

export const parentLookupFetch = async (data) => {
  return axios
    .get(API.parentSearch, { params: data })
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};
